import { GregorioBar } from '../../gregorio-chant/enums/GregorioBar';
import { ChantContext } from '../../gregorio-chant/ChantContext';
import { DivisioFinalis } from './DivisioFinalis';
import { DivisioMaior } from './DivisioMaior';
import { DivisioMinima } from './DivisioMinima';
import { DivisioMinimis } from './DivisioMinimis';
import { Virgula } from './Virgula';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';
import { DivisioMinor } from './DivisioMinor';

export function determine_bar(context: ChantContext, bar: GregorioBar): ChantLayoutElement {
  switch (bar) {
    case GregorioBar.VIRGULA:
      return new Virgula(context);
    case GregorioBar.VIRGULA_PAREN:
      return new Virgula(context, true, false);
    case GregorioBar.VIRGULA_HIGH:
      return new Virgula(context, false, true);
    case GregorioBar.VIRGULA_PAREN_HIGH:
      return new Virgula(context, true, true);

    case GregorioBar.DIVISIO_MINIMA:
      return new DivisioMinima(context);
    case GregorioBar.DIVISIO_MINIMA_PAREN:
      return new DivisioMinima(context, true);
    case GregorioBar.DIVISIO_MINIMA_HIGH:
      return new DivisioMinima(context, false, true);
    case GregorioBar.DIVISIO_MINIMA_PAREN_HIGH:
      return new DivisioMinima(context, true, true);

    case GregorioBar.DIVISIO_MINOR:
    case GregorioBar.DIVISIO_MINOR_D1:
    case GregorioBar.DIVISIO_MINOR_D2:
    case GregorioBar.DIVISIO_MINOR_D3:
    case GregorioBar.DIVISIO_MINOR_D4:
    case GregorioBar.DIVISIO_MINOR_D5:
    case GregorioBar.DIVISIO_MINOR_D6:
    case GregorioBar.DIVISIO_MINOR_D7:
    case GregorioBar.DIVISIO_MINOR_D8:
      return new DivisioMinor(context, bar);

    case GregorioBar.DIVISIO_MAIOR:
      return new DivisioMaior(context, false);
    case GregorioBar.DIVISIO_MAIOR_DOTTED:
      return new DivisioMaior(context, true);

    case GregorioBar.DIVISIO_MINIMIS:
      return new DivisioMinimis(context);
    case GregorioBar.DIVISIO_MINIMIS_HIGH:
      return new DivisioMinimis(context, true);

    case GregorioBar.DIVISIO_FINALIS:
      return new DivisioFinalis(context);
  }

  throw new Error('Not implemented');
}
